import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** Legacy route — utilization lives on program detail and org care programs tab. */
const AdminCareProgramUtilization = () => {
  const [searchParams] = useSearchParams();
  const program = searchParams.get('program');
  if (program) {
    return <Navigate to={`/plans/care-programs/${encodeURIComponent(program)}?tab=performance`} replace />;
  }
  return <Navigate to="/plans?tab=care-programs" replace />;
};

export default AdminCareProgramUtilization;
